'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fbemitter = require('fbemitter');

var _ = require('../../');

require('./loading.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoLoading = function (_Component) {
    _inherits(GeckoLoading, _Component);

    function GeckoLoading(props) {
        _classCallCheck(this, GeckoLoading);

        var _this = _possibleConstructorReturn(this, (GeckoLoading.__proto__ || Object.getPrototypeOf(GeckoLoading)).call(this, props));

        _this.state = {
            active: false
        };


        if (!_.GeckoLoadingService.emitter) _.GeckoLoadingService.emitter = new _fbemitter.EventEmitter();

        _.GeckoLoadingService.emitter.addListener('update', function () {
            var active = _.GeckoLoadingService.active;
            _this.setState({ active: active });
        });
        return _this;
    }

    _createClass(GeckoLoading, [{
        key: 'render',
        value: function render() {
            if (this.state.active) {
                return _react2.default.createElement(
                    'div',
                    { className: 'gecko-ui-loading' },
                    _react2.default.createElement(
                        'div',
                        { className: 'loading-wrapper' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'svg',
                                { xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', style: { margin: 'auto', display: 'block', shapeRendering: 'auto' }, width: '68px', height: '68px', viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid' },
                                _react2.default.createElement(
                                    'circle',
                                    { cx: '33', cy: '50', fill: '#004C97', r: '17' },
                                    _react2.default.createElement('animate', { attributeName: 'cx', repeatCount: 'indefinite', dur: '1s', keyTimes: '0;0.5;1', values: '33;67;33', begin: '-0.5s' })
                                ),
                                _react2.default.createElement(
                                    'circle',
                                    { cx: '67', cy: '50', fill: '#9ADBE8', r: '17' },
                                    _react2.default.createElement('animate', { attributeName: 'cx', repeatCount: 'indefinite', dur: '1s', keyTimes: '0;0.5;1', values: '33;67;33', begin: '0s' })
                                ),
                                _react2.default.createElement(
                                    'circle',
                                    { cx: '33', cy: '50', fill: '#004C97', r: '17' },
                                    _react2.default.createElement('animate', { attributeName: 'cx', repeatCount: 'indefinite', dur: '1s', keyTimes: '0;0.5;1', values: '33;67;33', begin: '-0.5s' }),
                                    _react2.default.createElement('animate', { attributeName: 'fill-opacity', values: '0;0;1;1', calcMode: 'discrete', keyTimes: '0;0.499;0.5;1', dur: '1s', repeatCount: 'indefinite' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'p',
                                null,
                                'Loading...'
                            )
                        )
                    )
                );
            }
            return null;
        }
    }]);

    return GeckoLoading;
}(_react.Component);

exports.default = GeckoLoading;